module.exports = __webpack_public_path__ + "static/img/logo-cbr.0dd11fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_spin/logo-cbr.png
// module id = n0XG
// module chunks = 4